module.exports = "listo-modal {\n  display: block;\n  text-align: center;\n  max-width: 500px;\n}\nlisto-modal ::ng-deep .modal {\n  padding: 20px 40px;\n}"